import APIService from './class';

class KpiCenter extends APIService {
  constructor() {
    super( '/kpiCenter' );
  }
  assign( token, params, options ) {
    return this.action( 'post', '/assign', params, options, token );
  }
}

export default new KpiCenter();
